import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
function isParkingTypeIncludedInRevamp(parkingType) {
    const isMatchingParkingType = parkingType === 'transient' ||
        parkingType === 'monthly' ||
        parkingType === 'event' ||
        parkingType === 'power_booking' ||
        parkingType === 'airport';
    return isMatchingParkingType;
}
export const useShowNewSearchHeader = () => {
    const { pathname } = useLocation();
    const parkingType = useSelector(getParkingType);
    const isMatchingParkingType = isParkingTypeIncludedInRevamp(parkingType);
    return (isMatchingParkingType &&
        (pathname === '/search' || pathname === '/search-decoupled'));
};
